<template>
  <div class="classroom-list">
    <div class="classroom-tit">
      <div class="tit-left">
        <span class="classroom-type">开课教室</span>
        <span class="classroom-name">{{ speakerClassroom.waterMark || '--' }}</span>
        <span class="icon_btn icon-edit2" @click.stop="handleClick(speakerClassroom)"></span>
        <span class="icon_btn icon-set2" @click="openSetting(speakerClassroom)"></span>
      </div>
      <div class="tit-right">
        AI自动导播
        <a-switch :disabled="liveDetail.status !== LIVE_STATUS.ING" v-model="isAutoGuide" class="auto-switch" @change="changeAutoSwitch"/>
      </div>
    </div>
    <!-- 主讲流start -->
    <div class="speaker-classroom">
      <div :class="`stream-item ${speakerStream.active ? 'active' : ''}`"
        v-for="(speakerStream, index) in (speakerCardList.length ? speakerCardList : [{}, {}])" :key="speakerStream.streamId"
        @click="selectStream(speakerClassroom.role, speakerStream, index)"
      >
        <div class="item-container" :data-streamId="speakerStream.streamId">
          <span class="device-type" v-if="speakerStream.deviceType">{{ speakerStream.deviceType }}</span>
          <!-- {{ speakerStream.streamId }} -->
          <video autoplay muted :id="`speakerClassroom_${index}`" v-show="speakerStream.streamId" :key="speakerStream.streamId"></video>
          <div class="mask" v-show="!speakerStream.streamId"></div>
          <div class="stream-footer" v-if="speakerStream.streamId">
            <div class="footer-left">
              <span :class="`icon_btn ${speakerStream.play ? 'icon-pause' : 'icon-play'}`" @click.stop="togglePlayStream('speakerCardList', speakerStream, index, `speakerClassroom_${index}`)"></span>
              <span class="stream-name">{{ speakerStream.deviceName || '--' }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 主讲流end -->
    <div class="classroom-tit">
      <div class="tit-left">
        <span class="classroom-type">互动教室</span>
      </div>
    </div>
    <!-- 听课流start -->
    <div class="listener-classroom">
      <div :class="`stream-item ${listenerClassroom.active ? 'active' : ''}`"
        v-for="(listenerClassroom, index) in (listenerCardList.length ? listenerCardList : [{}, {}])" :key="listenerClassroom.streamId"
        @click="selectStream(listenerClassroom.role, listenerClassroom, index)"
      >
        <div class="item-container" :data-streamId="listenerClassroom.streamId">
          <!-- {{ listenerClassroom.streamId }} -->
          <video autoplay muted :id="`listenerClassroom_${index}`" v-show="listenerClassroom.streamId" :key="listenerClassroom.streamId"></video>
          <div class="mask" v-show="!listenerClassroom.streamId"></div>
          <div class="stream-footer" v-if="listenerClassroom.streamId">
            <div class="footer-left">
              <span :class="`icon_btn ${listenerClassroom.play ? 'icon-pause' : 'icon-play'}`" @click.stop="togglePlayStream('listenerCardList', listenerClassroom, index, `listenerClassroom_${index}`)"></span>
              <span class="stream-name">{{ listenerClassroom.waterMark || '--' }}</span>
              <span class="icon_btn icon-edit" @click.stop="handleClick(listenerClassroom)"></span>
            </div>
            <div class="footer-right">
              <span :class="`icon_btn icon-mic ${listenerClassroom.disableMicrophone ? 'icon-mic-disabled' : ''}`" @click.stop="toggleMic(listenerClassroom)"></span>
              <span class="icon_btn icon-set" @click.stop="openSetting(listenerClassroom)"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 听课流end -->
    <!-- 修改弹窗start -->
    <a-modal v-model="showEditDialog" title="修改名称" :zIndex="1001"
      @ok="handleOk"
      :ok-button-props="{ props: { disabled: !newNickName } }"
    >
      <a-input placeholder="请输入名称"
        :value="newNickName"
        :maxLength="50"
        @change="changeNickName"
      />
    </a-modal>
    <!-- 修改弹窗end -->
    <inspection-tour-setting
      :inspectionTourSettingDialogFlag="inspectionTourSettingDialogFlag"
      @handleInspectionTourSettingDialogClose="handleInspectionTourSettingDialogClose"
      :dialogDetailInfo="dialogDetailInfo"
      :streamMap="streamMap"
      :clientForZRTC="clientForZRTC"
      :clientSettingsInfo="clientSettingsInfo"
      @getClientSettings="getClientSettings"
      :mediaDeviceInfo="mediaDeviceInfo"
      @switchVideo="switchVideo"
      @switchAudio="switchAudio"
      :classroomInspectionDetailInfo="classroomInspectionDetailInfo"
      :rtcType="rtcType"
      ref="refInspectionTourSetting"
    />
  </div>
</template>

<script>

import { openOrCloseAutoCaster, editNickName } from '@/server/api/guideStation'
import { checkRes } from '@/utils/tool'
import {ROLE} from '@/consts/user'
import {DEVICE_ROLE} from '@/consts/camera'
import {LIVE_STATUS} from '@/consts/live'
import { SOCKET_MSG_TYPE } from '@/consts/socketMsg'
export default {
  name: 'GuideStationTab', // 右侧导播台tab
  props: {
    liveId: String | Number,
    isPreviewing: Boolean,
    socketMsg: {
      type: Object,
      default() {
        return {}
      }
    },
    liveDetail: {
      type: Object,
      default() {
        return {}
      }
    },
    layoutChangeMsg: {
      type: Object,
      default() {
        return {}
      }
    },
    streamMap: {
      type: Map,
      default: new Map()
    },
    clientForZRTC: {
      type: Object | null,
      default: null
    },
    classroomList: {
      type: Array,
      default: []
    }
  },
  components: {
    'inspection-tour-setting': () => import('@/components/inspectionTourSetting')
  },
  watch: {
    socketMsg:{
      handler(nVal, oVal) {
        this.dealSocketMsg(nVal)
      },
      deep: true
    },
    'liveDetail.autoCaster': function (nVal) {
      this.isAutoGuide = nVal
    },

    // 布局切换信令内容,初始化选中卡片
    layoutChangeMsg: {
      handler(nVal) {
        if (this.isPreviewing) return
        setTimeout(() => { // 为了流发布信令已到，已有对应的流卡片
          this.updateSelectCardList(nVal)
        }, 500)
      },
      deep: true
    },

  },
  data () {
    return {
      LIVE_STATUS,
      userListOnMic: null,
      lastInfoDetail: null,

      isAutoGuide: false, // 自动导播
      speakerClassroom: {}, // 主讲教室详情
      speakerCardList: [], // 主讲流卡片
      listenerCardList: [], // 听课端流卡片

      selectCardList: [], // 选中的卡片

      showEditDialog: false, // 修改教室昵称弹窗
      curClassroom: {}, // 选中的当前教室
      newNickName: '',
      inspectionTourSettingDialogFlag: false,
      dialogDetailInfo: {},
      clientSettingsInfo: {},
      classroomInspectionDetailInfo: {},
      mediaDeviceInfo: {},
      rtcType: '',
      timerIdGetClientSettings: 0,
      timerIdGetDeviceInfo: 0,
      deviceNameObj: {
        'immerse-t': '主讲机位',
        'immerse-s': '学生机位'
      }
    }
  },
  methods: {
    // 清除卡片选中状态
    clearListActive() {
      this.speakerCardList.forEach((card, index) => {
        this.speakerCardList[index].active = false
      })
      this.listenerCardList.forEach((card, index) => {
        this.listenerCardList[index].active = false
      })
    },
    // 初始化选中卡片
    updateSelectCardList(layoutChangeMsg) {
      const panels = layoutChangeMsg.panels || []
      console.log(30871, 'layoutChangeMsg变化', layoutChangeMsg)
      this.clearListActive()
      const cardsTemp = []
      panels.forEach(panel => {
        const list = {
          1: this.speakerCardList, // 主讲
          2: this.listenerCardList // 听课
        }
        const targetIndex = list[panel.role].findIndex(i => panel.streamId === i.streamId)
        if (targetIndex >= 0) {
          list[panel.role][targetIndex].active = true
          cardsTemp.push(list[panel.role][targetIndex])
        }
      })
      this.selectCardList = [...cardsTemp]
      console.log(30873, 'updateSelectCardList this.selectCardList', this.selectCardList)
      this.$emit('selectCardList', this.selectCardList)
      this.$emit('operationDOM')
    },
    // updateSelectCardList(layoutChangeMsg) {
    //   const panels = layoutChangeMsg.panels || []
    //   console.log(30871, 'layoutChangeMsg变化', layoutChangeMsg)
    //   panels.forEach(panel => {
    //     const list = {
    //       1: this.speakerCardList, // 主讲
    //       2: this.listenerCardList // 听课
    //     }
    //     const targetIndex = list[panel.role].findIndex(i => panel.streamId === i.streamId)
    //     const exist = this.selectCardList.find(i => panel.streamId === i.streamId)
    //     if (exist) return
    //     if (targetIndex >= 0) {
    //       console.log(3084, '选中流卡片updateSelectCardList', targetIndex)
    //       list[panel.role][targetIndex].active = true
    //       this.selectCardList.push(list[panel.role][targetIndex])
    //     }
    //   })
    //   console.log(30872, 'updateSelectCardList this.selectCardList', this.selectCardList)
    //   this.$emit('selectCardList', this.selectCardList) // ?
    // },
    // 播放、暂停视频流
    togglePlayStream(listType, streamCard, index, id) {
      const targetVideoDom = document.querySelector(`#${id}`)
      if (streamCard.play) {
        targetVideoDom.pause()
        this.$emit('unsubscribeVideo', {streamCard, id})
      } else {
        targetVideoDom.play()
        this.$emit('subscribeVideo', {streamCard, id})
      }
      this[listType][index].play = !streamCard.play
    },

    // 切换麦克风状态
    toggleMic(classroom) {
      const { socketId, disableMicrophone } = classroom
      if (this.clientForZRTC.sendCustomSignal) {
        this.clientForZRTC.sendCustomSignal({
          txType: 'remote-control',
          to: socketId,
          content: {
            operationType: disableMicrophone ? 'enabled-audio-device' : 'disabled-audio-device',
          }
        })
      }
    },
    // 发送layoutchange
    // sendLayoutChange(newPanels) {
    //   if (this.clientForZRTC.sendCustomSignal) {
    //     this.clientForZRTC.sendCustomSignal({
    //       txType: 'layoutchange',
    //       to: socketId,
    //       content: {
    //         ...this.layoutChangeMsg,
    //         panels: [...newPanels]
    //       }
    //     })
    //   }
    // },
    // 编辑昵称
    changeNickName(e) {
      this.newNickName = e.target.value
    },

    async handleOk() {
      const self = this
      const res = await editNickName({
        liveId: this.liveId,
        userId: this.curClassroom.uid,
        nickname: this.newNickName
      })
      this.showEditDialog = false
    },

    // 修改名称
    handleClick(classroom) {
      this.curClassroom = classroom
      this.showEditDialog = true
      this.newNickName = classroom.waterMark
    },

    async dealSocketMsg(message) {
      const { type, content = {} } = message
      switch (type) {
        case SOCKET_MSG_TYPE.REMOTE_CONTROL: // 远程控制
          if (content.operationType === 'enabled-auto-caster') {
            this.isAutoGuide = true
            this.$emit('getLiveDetail')
          }
          if (content.operationType === 'disabled-auto-caster') {
            this.isAutoGuide = false
            this.$emit('getLiveDetail')
          }
          break
        case SOCKET_MSG_TYPE.DEVICE_LIST_ACK:
          if (Object.prototype.toString.call(content).slice(8, -1) === 'Object') {
            console.log(content, 'content_DEVICE_LIST_ACK')
            this.mediaDeviceInfo = content
          }
          break
        case SOCKET_MSG_TYPE.NICKNAME_CHANGE: // 昵称变更
          if (content.uid == this.speakerClassroom.uid) {
            this.speakerClassroom.waterMark = content.nickName
            return
          }
          const targetClassroomIndex = this.listenerCardList.findIndex(i => i.uid == content.uid)
          if (targetClassroomIndex >= 0) {
            this.listenerCardList[targetClassroomIndex].waterMark = content.nickName
            // console.log(1194, targetClassroomIndex, this.listenerCardList[targetClassroomIndex])
          }
          break

        case SOCKET_MSG_TYPE.ENABLED_DEVICE: // 设备启用
          if (content.mediaType.includes('audio')) {
            const targetEnableIndex = this.listenerCardList.findIndex(i => i.uid == content.uid)
            this.listenerCardList[targetEnableIndex].disableMicrophone = false
          }
          break
        case SOCKET_MSG_TYPE.DISABLED_DEVICE: // 设备禁用
          if (content.mediaType.includes('audio')) {
            const targetDisableIndex = this.listenerCardList.findIndex(i => i.uid == content.uid)
            this.listenerCardList[targetDisableIndex].disableMicrophone = true
          }
          break
        case SOCKET_MSG_TYPE.STREAM_CHANGED: // 流变更
          const updateItem = this.classroomList.find((item) => item.uid === content.uid) || {}
          const updateIndex = this.classroomList.findIndex((item) => item.uid === content.uid)
          const newClassroom = {
            ...updateItem,
            currentVideoDevice: [
              { ...((updateItem.currentVideoDevice || [])[0] || {}), streamId: content.streamId || '' }
            ]
          }
          updateIndex >= 0 && this.classroomList.splice(updateIndex, 1, newClassroom)
          const isDialogDetailInfo = (this.dialogDetailInfo || {}).uid === (content || {}).uid
          if (isDialogDetailInfo) {
            this.dialogDetailInfo = newClassroom
          }
          break
        case SOCKET_MSG_TYPE.OPEN_SCREEN:
          console.log(content, 'content_OPEN_SCREEN')
          const screenItem = {
            ...content,
            role: ROLE.SHARE_SCREEN
          }
          const existCard = this.speakerCardList.find(i => i.streamId === screenItem.streamId)
          if (!existCard) {
            const deviceInfo = content.deviceInfo || {}
            const newCard = {
              active: false,
              play: true,
              deviceName: '共享屏幕',
              role: screenItem.role,
              uid: content.uid,
              mediaLabel: content.mediaLabel,
              streamId: content.streamId,
              deviceRole: deviceInfo.roleType || content.mediaLabel,
              deviceType: deviceInfo.deviceType
            }
            console.log(newCard, 'newCard_newCard_newCard')
            this.speakerCardList.push(newCard)
            this.$emit('getSpeakerCardList', this.speakerCardList)
          }
          break
        case SOCKET_MSG_TYPE.STOP_SCREEN:
          console.log(content, 'content_STOP_SCREEN')
          // 主讲教室流列表中是否存在本次取消发布的流，流卡片消失
          const screenCard = this.speakerCardList.find(i => i.deviceName === '共享屏幕')
          if (screenCard) {
            const targetSpeakerCardIndex = this.speakerCardList.findIndex(i => i.streamId === screenCard.streamId)
            if (targetSpeakerCardIndex >= 0 && !screenCard.mediaLabel.includes('classroom')) {
              this.speakerCardList.splice(targetSpeakerCardIndex, 1)
              // 只有主讲本机设备和共享屏幕流卡片会消失，预览卡片也会消失
              const targetSelectCardListIndex = this.selectCardList.findIndex(i => i.streamId === screenCard.streamId)
              if (targetSelectCardListIndex >= 0) {
                this.selectCardList.splice(targetSelectCardListIndex, 1)
                this.$emit('selectCardList', this.selectCardList, 'updatePreviewPanel')
                this.$emit('delLayoutChangePanel', screenCard.streamId)
              }
            }
          }
          break
        case SOCKET_MSG_TYPE.USER_PUBLISHED: // 流发布
          console.log(11241, 'USER_PUBLISHED流发布', content)
          if (content.mediaType.includes('audio')) return
          // 主讲
          if (
            content.role === ROLE.SPEAKER &&
            content.mediaLabel !== 'r' && // 排除r流
            !content.streamId.includes('/0/') // 排除大流
          ) {
            if (content.mediaType === 'screen') {
              const existCard = this.speakerCardList.find(i => i.deviceName === '共享屏幕')
              if (existCard) {
                // mc球机
                const deviceInfo = content.deviceInfo || {}
                const newCard = {
                  active: false,
                  play: true,
                  deviceName: content.mediaLabel.includes('screen') ? '共享屏幕' : (deviceInfo.deviceName ? deviceInfo.deviceName : (['immerse-t', 'immerse-s'].includes(content.mediaLabel) ? this.deviceNameObj[content.mediaLabel] : '本机设备')),
                  role: content.role,
                  uid: content.uid,
                  mediaLabel: content.mediaLabel,
                  streamId: content.streamId,
                  deviceRole: deviceInfo.roleType || content.mediaLabel,
                  deviceType: deviceInfo.deviceType
                }
                const screenIndex = this.speakerCardList.findIndex((item) => item.role == ROLE.SHARE_SCREEN)
                this.speakerCardList.splice(screenIndex, 1, newCard)
                this.$emit('getSpeakerCardList', this.speakerCardList)
              }
            } else {
              const existCard = this.speakerCardList.find(i => i.streamId === content.streamId)
              if (existCard) return
              // mc球机
              const deviceInfo = content.deviceInfo || {}
              const newCard = {
                active: false,
                play: true,
                deviceName: content.mediaLabel.includes('screen') ? '共享屏幕' : (deviceInfo.deviceName ? deviceInfo.deviceName : (['immerse-t', 'immerse-s'].includes(content.mediaLabel) ? this.deviceNameObj[content.mediaLabel] : '本机设备')),
                role: content.role,
                uid: content.uid,
                mediaLabel: content.mediaLabel,
                streamId: content.streamId,
                deviceRole: deviceInfo.roleType || content.mediaLabel,
                deviceType: deviceInfo.deviceType
              }
              this.speakerCardList.push(newCard)
              this.$emit('getSpeakerCardList', this.speakerCardList)
            }            
          }

          // 听课端，取r流
          if (content.role === ROLE.LISTENER && content.mediaLabel === 'r') {
            const targetIndex = this.listenerCardList.findIndex(card => card.uid === content.uid)
            const newCard = {
              ...this.listenerCardList[targetIndex],
              socketId: content.socketId,
              streamId: content.streamId
            }
            this.listenerCardList.splice(targetIndex, 1, newCard)
            this.$emit('getListenerCardList', this.listenerCardList)
          }
          break
        case SOCKET_MSG_TYPE.USER_UNPUBLISHED: // 流取消发布
          console.log(1235, 'USER_UNPUBLISHED流取消发布', content)
          if (content.mediaType !== 'screen') {
            // 主讲教室流列表中是否存在本次取消发布的流，流卡片消失
            const targetSpeakerCardIndex = this.speakerCardList.findIndex(i => i.streamId === content.streamId)
            if (targetSpeakerCardIndex >= 0 && !content.mediaLabel.includes('classroom')) {
              this.speakerCardList.splice(targetSpeakerCardIndex, 1)
              // 只有主讲本机设备和共享屏幕流卡片会消失，预览卡片也会消失
              const targetSelectCardListIndex = this.selectCardList.findIndex(i => i.streamId === content.streamId)
              if (targetSelectCardListIndex >= 0) {
                this.selectCardList.splice(targetSelectCardListIndex, 1)
                this.$emit('selectCardList', this.selectCardList, 'updatePreviewPanel')
                this.$emit('delLayoutChangePanel', content.streamId)
              }
            }
          }
          

          // 互动教室取消发布的流，教室卡片取消选中状态
          // const targetListenerCardListIndex = this.listenerCardList.findIndex(i => i.streamId === content.streamId)
          // if (targetListenerCardListIndex >= 0) {
          //   // this.listenerCardList.splice(targetListenerCardListIndex, 1) // 注释原因：互动教室取消发布的流，教室卡片不能消失
          //   this.listenerCardList[targetListenerCardListIndex].active = false
          // }

          // 选中流列表中是否存在本次取消发布的流
          // const targetSelectCardListIndex = this.selectCardList.findIndex(i => i.streamId === content.streamId)
          // if (targetSelectCardListIndex >= 0) {
          //   this.selectCardList.splice(targetSelectCardListIndex, 1)
          //   this.$emit('selectCardList', this.selectCardList)
          // }
          break
        case SOCKET_MSG_TYPE.USER_UPDATE: // 用户变更
          console.log(1236, 'USER_UPDATE用户变更', content)
          if (content._delete && content._delete.role === ROLE.LISTENER) {
            // 删除听课卡片
            const targetIndex = this.listenerCardList.findIndex(i => i.uid == content._delete.uid)
            this.listenerCardList.splice(targetIndex, 1)
            // 删除选中卡片
            const targetSelectCardListIndex = this.selectCardList.findIndex(i => i.uid === content._delete.uid)
            if (targetSelectCardListIndex >= 0) {
              const targetSelect = this.selectCardList[targetSelectCardListIndex]
              this.selectCardList.splice(targetSelectCardListIndex, 1)
              console.log(3240002, targetSelectCardListIndex, targetSelect, this.selectCardList)
              this.$emit('selectCardList', this.selectCardList, 'updatePreviewPanel')
              this.$emit('delLayoutChangePanel', targetSelect.streamId)
            }

          }
          if (content._add && content._add.role === ROLE.LISTENER) {
            const newCard = {
              role: ROLE.LISTENER,
              active: false,
              play: true,
              uid: content._add.uid,
              waterMark: content._add.waterMark,
              // socketId: '', // 从流发布中拿
              disableMicrophone: false,
              // streamId: '' // 从流发布中拿
            }
            this.listenerCardList.push(newCard)
          }
          break
        case SOCKET_MSG_TYPE.LAST_INFO_DETAIL: // 终端快照
          // 初始化听课教室麦克风状态
          this.listenerCardList.forEach(card => {
            card.disableMicrophone = content[card.socketId].disableMicrophone
          })
          this.lastInfoDetail = content
          this.initDataList()
          break
        case SOCKET_MSG_TYPE.USER_LIST_ON_MIC: // 在麦用户列表
          this.userListOnMic = content
          this.initDataList()
          break
      }
    },
    // 初始化教室数据
    initDataList() {
      const { userListOnMic, lastInfoDetail } = this
      if (!userListOnMic || !lastInfoDetail) return
      // 主讲
      this.speakerClassroom = userListOnMic.find(i => i.role == ROLE.SPEAKER) || {}
      this.getSpeakerCardList()
      // 互动教室
      const listenerClassroomList = userListOnMic.filter(i => i.role == ROLE.LISTENER) || []
      this.listenerCardList = listenerClassroomList.map(i => ({
        ...i,
        active: false, // 默认未选中
        play: true, // 默认播放
        disableMicrophone: lastInfoDetail[i.socketInfos[0].socketId].disableMicrophone, // 默认音频设备为禁用
        streamId: i.rStreamId, // r流
      }))
      console.log(3086, this.speakerClassroom, this.listenerCardList)
      this.$emit('getListenerCardList', this.listenerCardList)
      this.updateSelectCardList(this.layoutChangeMsg)
    },
    // 获取主讲流卡片
    async getSpeakerCardList() {
      const { speakerClassroom, lastInfoDetail } = this
      // await this.getMcDeviceList(speakerClassroom)
      let speakerStreamlist = []
      speakerClassroom.socketInfos.forEach(socketInfo => {
        console.log(socketInfo, 'socketInfo_socketInfo_socketInfo')
        console.log(lastInfoDetail, 'lastInfoDetail_lastInfoDetail_lastInfoDetail')
        const streamList = lastInfoDetail[socketInfo.socketId].streamInfo.filter(
          stream =>
            (stream.mediaType === 'video' || (stream.mediaType === 'screen' && lastInfoDetail[socketInfo.socketId].openScreen)) &&
            stream.status === 'published' &&
            stream.mediaLabel !== 'r' && // 排除r流
            stream.mediaLabel !== 'mix' && // 排除mix流
            !stream.streamId.includes('/0/') // 排除大流
        )
        speakerStreamlist = [...speakerStreamlist, ...streamList]
      })
      this.speakerCardList = speakerStreamlist.map(speakerStream => {
        const deviceInfo = speakerStream.deviceInfo || {}
        return {
          ...speakerStream,
          role: speakerClassroom.role,
          active: false, // 默认未选中
          play: true, // 默认播放
          deviceName: speakerStream.mediaLabel.includes('screen') ? '共享屏幕' : (deviceInfo.deviceName ? deviceInfo.deviceName : (['immerse-t', 'immerse-s'].includes(speakerStream.mediaLabel) ? this.deviceNameObj[speakerStream.mediaLabel] : '本机设备')),
          deviceRole: deviceInfo.roleType || speakerStream.mediaLabel, // 机位角色
          deviceType: deviceInfo.deviceType
        }
      })
      console.log(3087, 'speakerStreamlist', speakerStreamlist)
      console.log(3088, 'this.speakerCardList', this.speakerCardList)
      this.$emit('getSpeakerCardList', this.speakerCardList)
      this.updateSelectCardList(this.layoutChangeMsg)
    },
    selectStream(role, item, index) {
      if (!item.streamId) return
      const existSameDeviceRole = this.selectCardList.find(i => i.deviceRole === item.deviceRole && !item.active)
      if (role === ROLE.SPEAKER && existSameDeviceRole) {
        const text = {
          1: '老师机位',
          2: '学生机位',
        }
        this.$message.error(`只能选择一个${text[item.deviceRole]}！`)
        return
      }

      const list = {
        1: this.speakerCardList, // 主讲
        2: this.listenerCardList // 听课
      }

      const targetIndex = this.selectCardList.findIndex(i => i.streamId === item.streamId)
      if (targetIndex >= 0) {
        this.selectCardList.splice(targetIndex, 1)
      } else {
        this.selectCardList.push(list[role][index])
      }
      list[role][index].active = !list[role][index].active
      this.$emit('changeIsPreviewing', true)
      this.$emit('selectCardList', this.selectCardList)
      this.$emit('operationDOM')
    },
    // 切换ai自动导播
    async changeAutoSwitch(checked) {
      const self = this
      const res = await openOrCloseAutoCaster({
        liveId: this.liveId,
        autoCaster: checked
      })
      checkRes({
        res,
        success() {
          self.isAutoGuide = checked
        },
        failed() {
          self.isAutoGuide = !checked
        }
      })
      this.$emit('getLiveDetail')
    },
    handleInspectionTourSettingDialogClose() {
      this.inspectionTourSettingDialogFlag = false
    },
    async getClientSettings() {
      try {
        const { macAddr } = this.classroomInspectionDetailInfo
        const params = {
          macAddr
        }
        const result = await this.$http.clientSettingGet(params)
        if (result.code !== 200) return
        this.clientSettingsInfo = result.rt || {}
      } catch (err) {
        console.log(err)
      }
    },
    switchVideo(videoDeviceSelected) {
      const { socketId } = this.classroomInspectionDetailInfo
      if (this.clientForZRTC.sendCustomSignal) {
        this.clientForZRTC.sendCustomSignal({
          txType: 'remote-control',
          to: socketId,
          content: {
            operationType: 'switch-video',
            deviceId: videoDeviceSelected
          }
        })
      }
    },
    switchAudio(audioDeviceSelected) {
      const { socketId } = this.classroomInspectionDetailInfo
      if (this.clientForZRTC.sendCustomSignal) {
        this.clientForZRTC.sendCustomSignal({
          txType: 'remote-control',
          to: socketId,
          content: {
            operationType: 'switch-audio',
            deviceId: audioDeviceSelected
          }
        })
      }
    },
    async openSetting (classroom) {
      this.timerIdGetClientSettings && clearInterval(this.timerIdGetClientSettings)
      this.timerIdGetDeviceInfo && clearInterval(this.timerIdGetDeviceInfo)
      this.inspectionTourSettingDialogFlag = true
      const { classroomId: classroomCode } = classroom
      const itemByClassroomCode = this.classroomList.find(item => item.classroomId === classroomCode)
      if (itemByClassroomCode) {
        this.dialogDetailInfo = itemByClassroomCode
      }
      await this.getClassroomInspectionDetail(this.liveId, classroomCode)
      // 获取设置：
      this.getClientSettings()
      this.timerIdGetClientSettings = setInterval(() => {
        this.getClientSettings()
      }, 2000)
      // 获取设备列表：
      this.getDeviceInfo()
      this.timerIdGetDeviceInfo = setInterval(() => {
        this.getDeviceInfo()
      }, 2000)
    },
    async getClassroomInspectionDetail(liveId, classroomCode) {
      try {
        const params = {
          liveId,
          classroomCode
        }
        const result = await this.$http.classroomInspectionDetail(params)
        if (result.code !== 200) return
        this.classroomInspectionDetailInfo = result.rt || {}
      } catch (err) {
        console.log(err)
      }
    },
    getDeviceInfo() {
      this.sendCustomSignal('device-list', {})
    },
    sendCustomSignal(txType, content) {
      const { socketId } = this.classroomInspectionDetailInfo
      if (this.clientForZRTC.sendCustomSignal) {
        this.clientForZRTC.sendCustomSignal({
          txType,
          to: socketId,
          content: {
            ...content
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .classroom-list{
    padding: 0 1.6rem;
    .classroom-tit{
      color: #1E2228;
      display: flex;
      justify-content: space-between;
      margin-bottom: 1.6rem;
      .tit-left{
        display: flex;
        align-items: center;
        max-width: 70%;
      }
      .classroom-type{
        font-weight: 600;
        font-size:2.0rem;
        position: relative;
        &::before{
          content: '';
          position: absolute;
          left: 0;
          right: 0;
          top: 50%;
          bottom: 0;
          background: linear-gradient(270deg, rgba(22,114,255,0) 0%, rgba(22,114,255,0.2) 100%);
        }
      }
      .classroom-name{
        font-size: 1.6rem;
        margin-left: .8rem;
        max-width: 56%;
        text-overflow: ellipsis;
        text-wrap: nowrap;
        overflow: hidden;
      }
      .tit-right{
        display: flex;
        align-items: center;
        .auto-switch{
          margin-left:.5rem;
        }
      }
    }
  }
  .speaker-classroom,
  .listener-classroom{
    display: flex;
    flex-flow: wrap;
    justify-content: space-between;
    width: 100%;
    margin-bottom: .5rem;
    .stream-item{
      width: 49%;
      padding-top: 26.5%;
      border: .4rem solid #fff;
      border-radius: .4rem;
      margin-bottom: 1.0rem;
      position: relative;
      cursor: pointer;
      overflow: hidden;
      &.active{
        border-color: #FF8316;
      }
      .item-container{
        position: absolute;
        top:0;
        left:0;
        right:0;
        bottom:0;
        background: rgba(22,114,255,0.1);
        .device-type{
          position: absolute;
          top:0;
          left:0;
          padding: 2px;
          font-size: 12px;
          color: #fff;
          background: rgba(0, 0, 0, 0.6);
          border-radius: 0 0 4px 0;
        }
        video {
          width: auto;
          height: 100%;
          background-color: #000;
          object-fit: fill;
        }
        .mask{
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          display: flex;
          justify-content: center;
          align-items: center;

          &::after{
            content: '';
            display: inline-block;
            width: 2.4rem;
            height: 2.4rem;
            background-image: url('~@/assets/img/guideStation/icon-nosignal@2x.png');
            background-repeat: no-repeat;
            background-size: cover;
          }
        }
      }
      .stream-footer{
        padding: 0 .8rem;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        height: 3.0rem;
        background: rgba(0, 0, 0, 0.6);
        color: #fff;
        font-size:1.4rem;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .footer-left{
          flex: 1;
          max-width: calc(100% - 3.8rem);
          display: flex;
          align-items: center;
        }
        .footer-right{
          display: flex;
          width: 3.8rem;
        }

        .stream-name{
          display: inline-block;
          margin-left:.4rem;
          text-wrap: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          max-width: 70%;
        }

      }
    }

  }
  .icon_btn{
    display: inline-block;
    width: 1.6rem;
    height: 1.6rem;
    background-repeat: no-repeat;
    background-size:cover;
    cursor: pointer;
    &:hover{
      opacity: 0.8;
    }
    &.icon-set2{
      width:1.4rem;
      height:1.4rem;
      background:url('~@/assets/img/guideStation/icon-set@2x.png') no-repeat;
      background-size:cover;
      display: inline-block;
      margin-left: .8rem;
    }
    &.icon-edit2{
      margin-left:.4rem;
      background-image: url('~@/assets/img/guideStation/icon-edit2@2x.png');
    }
    &.icon-edit{
      margin-left:.4rem;
      background-image: url('~@/assets/img/guideStation/icon-edit@2x.png');
    }
    &.icon-mic{
      background-image: url('~@/assets/img/guideStation/icon-mic-enabled@2x.png');
    }
    &.icon-mic-disabled{
      background-image: url('~@/assets/img/guideStation/icon-mic-disabled@2x.png');
    }
    &.icon-set{
      margin-left: .5rem;
      background-image: url('~@/assets/img/guideStation/icon-set2@2x.png');
    }
    &.icon-play{
      background-image:url('~@/assets/img/guideStation/icon-play@2x.png');
    }
    &.icon-pause{
      background-image: url('~@/assets/img/guideStation/icon-pause@2x.png');
    }

  }
  .speaker-classroom .stream-item .stream-footer .footer-left{
    max-width: 100%;
  }

  .speaker-classroom .stream-item .stream-footer .stream-name{
    max-width: 90%;
  }
</style>